import { render, staticRenderFns } from "./crmAccounts.vue?vue&type=template&id=3858ef3e"
import script from "./crmAccounts.vue?vue&type=script&lang=js"
export * from "./crmAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports